export default __webpack_public_path__ + "static/media/Helm of the Forsaken.723f6960.jpg";